import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function ParameterReducer(state = initialState.parameter, action: any) {
  switch (action.type) {
    case types.SAVE_PARAMETER_SUCCESS:
      return action.parameter;
    default:
      return state;
  }
}
